import { resolveResourceURl } from "./urlResolver";

// CDN
export const LOGO_MEDIAS = "https://cdn.schaeffler-ecommerce.com/frontend/logos/medias.svg";
export const LOGO_MEDIAS_PLUS = "https://cdn.schaeffler-ecommerce.com/frontend/logos/medias_plus.svg";
export const LOGO_MEDIAS_BUSINESS = "https://cdn.schaeffler-ecommerce.com/frontend/logos/medias_business.svg";
export const LOGO_MEDIAS_PLUS_BUSINESS = "https://cdn.schaeffler-ecommerce.com/frontend/logos/medias_plus_business.svg";
export const LOGO_MEDIAS_GROWTH = "https://cdn.schaeffler-ecommerce.com/frontend/logos/medias_growth.svg";

// Icons directory
export const ICON_CAD = resolveResourceURl("/icons/cad.svg");

// Images directory
export const LOGO_FAG = resolveResourceURl("/images/FAG_logo.png");
export const LOGO_INA = resolveResourceURl("/images/INA_logo.png");

export const IMG_SPINNER = resolveResourceURl("/images/spinner.gif");

export const IMG_REGISTRATION = resolveResourceURl("/images/registration.png");

export const IMG_MARKER = resolveResourceURl("/images/gmaps-marker.png");
export const IMG_MARKER_ACTIVE = resolveResourceURl("/images/gmaps-marker-active.png");

export const IMG_OPTIME_PARTS = resolveResourceURl("/images/optime-three-parts.jpg");
export const IMG_ORDER_SUCCESS = resolveResourceURl("/images/order_thanku.svg");
export const IMG_MAP_BLOCKED = resolveResourceURl("/images/blocked_map.svg");

export const IMG_EMPTY_CART = resolveResourceURl("/images/empty_cart.svg");
export const IMG_QUOTE_CONFIRMATION = resolveResourceURl("/images/quote-confirmation.svg");
export const IMG_NO_RESULTS = resolveResourceURl("/images/no-results.svg");
export const IMG_NO_RESULTS_PRODUCT_COMPARISON = resolveResourceURl("/images/no-results-product-comparison.svg");
export const IMG_EMPTY_STATE = resolveResourceURl("/images/empty_state.svg");
export const MAIL_SENT = resolveResourceURl("/images/illustration_welcome_email.svg");
export const HOUSING_SELECTION_ASSISTANT_ICON = "https://cdn.schaeffler-ecommerce.com/cdn/0001ACB0_d.png";
export const IMG_EMPTY_NOTIFICATIONS = resolveResourceURl("/images/illustration_notifications.png");
export const IMG_EMPTY_WISHLIST = resolveResourceURl("/images/empty_wishlist.svg");

export const IMG_STOPWATCH = resolveResourceURl("/images/in-progress.svg");
export const IMG_STOPWATCH_GRAY = resolveResourceURl("/images/in-progress-gray.svg");
export const IMG_DMC_TEASER = resolveResourceURl("/images/scandmc_teaser.svg");
export const IMG_DMC_LEFT = resolveResourceURl("/images/dmc-product.svg");
export const IMG_DMC_RIGHT = resolveResourceURl("/images/dmc-pkg.svg");
export const IMG_DMC_PKG_ONLY = resolveResourceURl("/images/dmc-pkg-only.svg");
export const IMG_SUCCESSOR_BOX = resolveResourceURl("/images/suprise-box.svg");
export const IMG_SUCCESSOR_ARROW = resolveResourceURl("/images/successor-arrow.svg");

export const IMG_CART_STEP_1 = resolveResourceURl("/images/cart_merge_1_inactive.svg");
export const IMG_CART_STEP_1_ACTIVE = resolveResourceURl("/images/cart_merge_1_active.svg");
export const IMG_CART_STEP_3 = resolveResourceURl("/images/cart_merge_3_inactive.svg");
export const IMG_CART_STEP_3_ACTIVE = resolveResourceURl("/images/cart_merge_3_active.svg");

export const IMG_SALES_PARTNER_FINDER_CART = resolveResourceURl("/images/spfcart.png");

export const IMG_REQUEST_SUCCESS = resolveResourceURl("/images/request_thanku.svg");
export const IMG_UPLOAD_IMAGE = resolveResourceURl("/images/upload_image.svg");

export const IMG_MISSING_PRODUCT = resolveResourceURl("/images/missing_product_EN_300x300.jpg");

export const IMG_CONTRACTS_CART = resolveResourceURl("/images/contracts_cart.png");
export const IMG_CONTRACTS_CALENDAR = resolveResourceURl("/images/contracts_calendar.png");
export const IMG_CONTRACTS_SPEED = resolveResourceURl("/images/contracts_speed.png");
export const IMG_CONTRACTS_USERS = resolveResourceURl("/images/contracts_users.png");

export const IMG_FCC_TOOLTIP = resolveResourceURl("/images/fcc_tooltip.png");

export const IMG_FCC_INTRO_1 = resolveResourceURl("/images/fcc-intro-1.png");
export const IMG_FCC_INTRO_2 = resolveResourceURl("/images/fcc-intro-2.png");
export const IMG_FCC_INTRO_3 = resolveResourceURl("/images/fcc-intro-3.png");
export const IMG_FCC_INTRO_4 = resolveResourceURl("/images/fcc-intro-4.png");

export const MICROSOFT_TEAMS = resolveResourceURl("/images/microsoft_teams.svg");

export const IMG_NO_PRODUCT_BUNDLE = resolveResourceURl("/images/no-product.svg");

export const IMG_SELF_REGISTRATION_SUCCESS = resolveResourceURl("/images/self-registration-success.svg");

export const IMG_NO_RESULTS_OR_MATCHES = resolveResourceURl("/images/no-results-or-matches.svg");
export const IMG_CPD_PROGRESS = resolveResourceURl("/images/cpd-progress-image.svg");

// L1 Category images
export const IMG_CATEGORY_BEARINGS = resolveResourceURl("/images/categories/bearings.jpg");
export const IMG_CATEGORY_DIRECT_DRIVES = resolveResourceURl("/images/categories/direct-drives.jpg");
export const IMG_CATEGORY_HOUSINGS = resolveResourceURl("/images/categories/housings.jpg");
export const IMG_CATEGORY_LINEAR = resolveResourceURl("/images/categories/linear.jpg");
export const IMG_CATEGORY_SERVICE = resolveResourceURl("/images/categories/service.jpg");
